import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function Hero() {
  const scrollToStrategies = () => {
    document.querySelector('#strategies')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative min-h-screen flex items-center pt-20 overflow-hidden bg-hero-glow" data-id="element-93">
      {/* Background Elements */}
      <div className="absolute inset-0 z-0" data-id="element-94">
        {/* Large Geometric Shape */}
        <motion.div initial={{
        opacity: 0,
        rotate: 0
      }} animate={{
        opacity: 1,
        rotate: 45
      }} transition={{
        duration: 2,
        ease: 'easeOut'
      }} className="absolute top-1/2 right-[-10%] w-[700px] h-[700px] border border-gold-400/[0.04] -translate-y-1/2 pointer-events-none" data-id="element-95"></motion.div>

        {/* Second smaller geometric shape */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 3,
        delay: 0.5
      }} className="absolute top-[15%] right-[15%] w-[300px] h-[300px] border border-gold-400/[0.03] rotate-12 pointer-events-none" data-id="element-96"></motion.div>

        {/* Bottom gradient fade into next section */}
        <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-base-950 to-transparent" data-id="element-97"></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10 w-full" data-id="element-98">
        <div className="max-w-4xl" data-id="element-99">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} data-id="element-100">
            <div className="inline-flex items-center gap-3 text-gold-400/70 text-xs tracking-[0.25em] uppercase mb-10" data-id="element-101">
              <div className="w-8 h-[1px] bg-gold-400/40" data-id="element-102"></div>
              Alternative Investment Strategies
            </div>

            <h1 className="text-4xl md:text-6xl lg:text-7xl text-white tracking-tight leading-[1.08] mb-6" data-id="element-103">
              <span className="font-light" data-id="element-104">Capitalizing on the</span>{' '}
              <br className="hidden md:block" data-id="element-105" />
              <span className="font-bold text-gold-300" data-id="element-106">
                Forces That Move Markets.
              </span>
            </h1>

            {/* Animated horizontal line */}
            <motion.div initial={{
            width: 0
          }} animate={{
            width: '60%'
          }} transition={{
            duration: 1.5,
            delay: 0.5,
            ease: 'easeInOut'
          }} className="h-[1px] bg-gradient-to-r from-gold-400 to-transparent mb-8" data-id="element-107"></motion.div>
          </motion.div>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: 'easeOut'
        }} className="text-lg md:text-xl text-slate-400 max-w-2xl leading-relaxed mb-12" data-id="element-108">
            Delta Street identifies high-conviction opportunities driven by
            structural forces — government contracts, policy shifts, sector
            momentum, and macro positioning.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.4,
          ease: 'easeOut'
        }} className="flex flex-col sm:flex-row gap-4" data-id="element-109">
            <button onClick={scrollToStrategies} className="group flex items-center justify-center gap-3 px-8 py-4 bg-gold-400 text-slate-950 font-semibold tracking-wider hover:bg-gold-300 transition-all duration-300" data-id="element-110">
              Our Strategies
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-111" />
            </button>
            <button onClick={() => document.querySelector('#about')?.scrollIntoView({
            behavior: 'smooth'
          })} className="flex items-center justify-center px-8 py-4 border border-slate-700 text-slate-300 tracking-wider hover:border-slate-500 hover:text-white transition-all duration-300" data-id="element-112">
              Investment Philosophy
            </button>
          </motion.div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1,
      duration: 1
    }} className="absolute bottom-12 left-6 md:left-12 flex flex-col items-center gap-4" data-id="element-113">
        <div className="text-[10px] text-slate-500 uppercase tracking-[0.3em] rotate-90 origin-left translate-x-3" data-id="element-114">
          Scroll
        </div>
        <div className="w-[1px] h-16 bg-gradient-to-b from-gold-400 to-transparent" data-id="element-115"></div>
      </motion.div>
    </section>;
}